export default __webpack_public_path__ + "static/media/byo-food.8c9c0bf4.svg";